module.exports = __webpack_public_path__ + "img/1293184351.6d57cbd1.jpg";